import React from 'react';
import SharedDrawer from '../Shared/SharedDrawer';
import { getImageSrc } from '../../utils/cmsAPI';

const ArticleDrawer = ({ open, onClose, article }) => {
  if (!article) return null;

  return (
    <SharedDrawer
      open={open}
      onClose={onClose}
      title={article.title}
      content={article.body}
      image={article.image ? getImageSrc(article.image) : null}
    />
  );
};

export default ArticleDrawer;